const UNTITLED = 'Untitled';

/** Creator-facing floor. Never rendered on consumer surfaces. */
export const UNTITLED_FALLBACK = UNTITLED;

/**
 * Resolve a video title to something worth rendering, or `null` when there
 * isn't one.
 *
 * The backend made `videos.title` nullable (BE 289070c), so a short uploaded
 * without one comes back as `null`. The literal string "Untitled" counts as
 * absent too: the fetch-from-URL path writes it when it can't derive a name
 * from the source URL, and Bunny stores it as an internal dashboard label.
 * Neither is a title a creator chose, so neither should reach a viewer.
 */
export function resolveVideoTitle(title: string | null | undefined): string | null {
  const trimmed = title?.trim();
  if (!trimmed) return null;
  if (trimmed.toLowerCase() === UNTITLED.toLowerCase()) return null;
  return trimmed;
}

/**
 * Creator-facing label — studio rows, contextual sidebar, upload indicator.
 *
 * Never empty: a studio row with no text is unidentifiable and its click
 * target invisible. Consumer surfaces use `resolveVideoTitle` and render
 * nothing instead.
 */
export function getVideoTitleDisplay(title: string | null | undefined): string {
  return resolveVideoTitle(title) ?? UNTITLED_FALLBACK;
}
